<script lang="ts" setup>
import type { FormKitNode } from '@formkit/core'

const { $t } = useNuxtApp()
const forbiddenCharacters: string[] = ['+', '-']
const errorMsg = ref<string>($t('Číslo zmluvy musí mať 8 alebo 10 číslic'))

const agreement = (node: FormKitNode): boolean => {
    // get input value
    const value: string = node.value as string
    // validate value
    const lengthValidation: boolean = value.length === 8 || value.length === 10
    const charsValidation: boolean = !value
        .split('')
        .some((char) => forbiddenCharacters.includes(char))
    // validate
    return lengthValidation && charsValidation
}
</script>
<template>
  <FormKit
    validation="required:trim|number|agreement"
    :validation-rules="{ agreement }"
    :validation-messages="{
      agreement: errorMsg,
      required: errorMsg,
      number: errorMsg,
    }"
    name="agreement_number"
    :label="$t('Číslo poistnej zmluvy / Číslo návrhu zmluvy')"
  />
</template>
